<template lang="pug">
  div(:class="{ 'has-error': !valid, 'form-group': true }")
    .vfl-field.input-group(style='width: 100%;')
      input(
        type="text",
        required="",
        :value="value",
        @input="$emit('input', $event.target.value)"
      )
      span.field-underline
      label {{ label }}

    span.help-block.error(v-if="!valid") {{ message }}
</template>

<script>
    export default {
        name: 'StringInput',

        props: {
            value: {
                type: String
            },
            label: {
                type: String
            },

            valid: {
                type: Boolean,
                default: true
            },
            message: {
                type: String,
                default: ''
            }
        }
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/lib/fields/StringInput.vue